'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fullscreenItemPreload = require('./fullscreenItemPreload.js');

var _fullscreenItemPreload2 = _interopRequireDefault(_fullscreenItemPreload);

var _utils = require('../utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenImage = function (_React$Component) {
  (0, _inherits3.default)(FullscreenImage, _React$Component);

  function FullscreenImage(props) {
    (0, _classCallCheck3.default)(this, FullscreenImage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenImage.__proto__ || (0, _getPrototypeOf2.default)(FullscreenImage)).call(this, props));

    _this.retryOnError = _this.retryOnError.bind(_this);
    _this.onLoadImage = _this.onLoadImage.bind(_this);

    _this.state = {
      loaded: false,
      failed: false,
      retries: 1
    };
    return _this;
  }

  (0, _createClass3.default)(FullscreenImage, [{
    key: 'retryOnError',
    value: function retryOnError(e) {
      if (this.state.failed) {
        return false;
      } else if (this.state.retries > 3) {
        console.error('Error (including retries) loading item #' + this.props.item, e);
        this.setState({
          failed: true
        });
      } else {
        this.setState({
          retries: this.state.retries + 1
        });
      }
    }
  }, {
    key: 'onLoadImage',
    value: function onLoadImage() {
      this.setState({
        loaded: true
      });
    }
  }, {
    key: 'getItemScaleByContainerSize',
    value: function getItemScaleByContainerSize(item, _ref) {
      var width = _ref.width,
          height = _ref.height;

      var ratio = width / height;
      var cutByWidth = ratio > item.ratio;
      var scaleHeight = item.height / height;
      var scaleWidth = item.width / width;
      return cutByWidth ? scaleHeight : scaleWidth;
    }
  }, {
    key: 'retryUrl',
    value: function retryUrl() {
      var item = this.props.item;

      var url = item.resized_url.img;

      var hasGetParam = url.indexOf('?') >= 0;

      if (!hasGetParam && !this.state.failed) {
        // url += hasGetParam ? '&' : '?';
        url += '?retry=' + this.state.retries;
      }

      return url;
    }
  }, {
    key: 'onContextMenu',
    value: function onContextMenu(e) {
      e.preventDefault(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var item = this.props.item;

      var scale = this.props.window.scale.min(item);
      if (this.props.isZoom) {
        var isLandscape = window.orientation === 90 || window.orientation === -90;
        var height = $(window.document).height();
        var width = $(window.document).width();
        scale = this.getItemScaleByContainerSize(item, {
          width: isLandscape ? height : width,
          height: isLandscape ? width : height
        });
      }

      var transform = 'translate3d(-50%, -50%, 0) scale(' + scale + ')';
      var innerStyle = {
        width: item.width + 'px',
        height: item.height + 'px',
        transform: transform,
        WebkitTransform: transform,
        MozTransform: transform,
        msTransform: transform,
        OTransform: transform
      };

      if (this.props.isMobile) {
        innerStyle.outline = '1px solid transparent'; //hack for mobile, adds blur to make the picture look better
      }

      return !this.props.isDummy ? _react2.default.createElement(
        'div',
        { onContextMenu: function onContextMenu(e) {
            return _this2.onContextMenu(e);
          } },
        _react2.default.createElement(_fullscreenItemPreload2.default, {
          window: this.props.window,
          loaded: this.state.loaded,
          item: item,
          scale: scale
        }),
        _react2.default.createElement('img', {
          'data-hook': 'fullscreen-image',
          className: 'fullscreen-content fullscreen-item pro-fullscreen-high-res ' + (this.state.loaded ? ' gallery-item-loaded ' : '') + (this.state.failed ? ' pro-fullscreen-error ' : ''),
          src: this.retryUrl(),
          alt: item.alt,
          onError: this.retryOnError,
          onLoad: this.onLoadImage,
          key: 'image',
          style: innerStyle
        })
      ) : _react2.default.createElement('div', null);
    }
  }]);
  return FullscreenImage;
}(_react2.default.Component);

exports.default = FullscreenImage;